import {
  formatDate,
  MbscCalendarEvent,
  MbscDatepickerOptions,
  MbscEventcalendarOptions,
  MbscEventcalendarView,
  MbscPopup,
  MbscPopupOptions,
  momentTimezone,
} from '@mobiscroll/angular';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { forkJoin, Observable } from 'rxjs';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { data } from 'jquery';
import * as moment from 'moment-timezone';
import { WORKING_TIME_CONFIG } from 'src/app/config/calendar.config';

declare var jQuery: any;

momentTimezone.moment = moment;
const monthNames = [
  'Jan',
  'Feb',
  'March',
  'April',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

@Component({
  selector: 'app-reschedule-follow-up',
  templateUrl: './reschedule-follow-up.component.html',
  styleUrls: ['./reschedule-follow-up.component.scss'],
})
export class RescheduleFollowUpComponent implements OnInit {
  show: boolean = false;
  userRole: any;
  apptId: any;
  apptDetails: any;
  myResources: any[] = [];
  locationId: any = '';
  events: any;
  locationName: any;
  resourceName: any;
  invalid: any = [
    {
      start: '0001-01-00',
      end: new Date(new Date().setDate(new Date().getDate() - 1)),
    },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private appointmentService: AppointmentService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    //this.show = false
    this.spinner.show();
    console.log('Page Open');
    this.userRole = this.auth.getUserType();
    this.activatedRoute.params.subscribe((params) => {
      this.apptId = params['id'];
    });
    this.appointmentService
      .getAppointments(null, null, null, this.apptId, null, null)
      .subscribe((data) => {
        this.apptDetails = data.data[0];
        this.locationId = this.apptDetails.appointmentDetails.locationId;
        this.locationName = this.apptDetails.appointmentDetails.location;
        // this.diagId = this.apptDetails.appointmentDetails.diagnosticianId;
        this.resourceName =
          this.apptDetails.appointmentDetails.schedules[1].adminName;
        // this.scheduleId = this.apptDetails.appointmentDetails.schedules[0].scheduleId;
      });

    //this.show = true;
    this.spinner.hide();
    console.log('Page close');
  }

  openFollowUpModal() {
    this.spinner.show();
    this.show = false;
    this.myResources = [];
    this.invalid = [
      {
        start: '0001-01-00',
        end: new Date(new Date().setDate(new Date().getDate() - 1)),
      },
    ];
    this.events = [];

    forkJoin({
      // user:     this.appointmentService.getUser(null, 1003),
      director: this.appointmentService.getUser(this.locationId, 1004),
      requestTwo: this.appointmentService.getAppointments(
        null,
        null,
        null,
        null,
        null,
        null
      ),
      requestThree: this.appointmentService.getDiagUnavailability(
        null,
        this.locationId,
        1004
      ),
    }).subscribe(({ director, requestTwo, requestThree }) => {
      // user.data.forEach((admin :any)=> {
      //   let diagdetails = {
      //     id: admin.id,
      //     name: admin.firstName,
      //     img: 'https://img.mobiscroll.com/demos/m2.png',
      //   }
      //   this.myResources.push(diagdetails)

      // });

      director.data.forEach((dir: any) => {
        let diagdetails = {
          id: dir.id,
          name: dir.firstName,
          img: 'https://img.mobiscroll.com/demos/m2.png',
        };
        this.myResources.push(diagdetails);
      });

      requestTwo.data.forEach((el: any) => {
        let schedules = el.appointmentDetails.schedules;
        console.log('length    ' + schedules.length);
        if (schedules[schedules.length - 1].status == 'FOLLOWUP') {
          let appt = schedules[schedules.length - 1];
          if (schedules[0].status != 'CANCEL') {
            this.invalid.push(appt);
          }
        }
      });

      this.events = requestThree;
      this.events.data.forEach((element: any) => {
        this.invalid.push(element);
      });
      this.events.dataRec.forEach((element: any) => {
        this.invalid.push(element);
      });

      setTimeout(() => {
        jQuery('#followUpModal').modal('show');
      });

      this.spinner.hide();
      this.show = true;
    });
  }
  reset: any = 'Close';
  myEvents: MbscCalendarEvent[] = [];
  assessmentDate: any;
  appointmentTime!: string;
  clickToCreate: any = 'single';
  tempEvent!: MbscCalendarEvent;
  @ViewChild('popup', { static: false })
  popup!: MbscPopup;
  @ViewChild('colorPicker', { static: false })
  colorPicker: any;
  popupEventTitle: string | undefined;
  popupEventDescription = '';
  popupEventAllDay = true;
  popupEventDates: any;
  assignedAdmin: any;
  datePickerOptions: MbscDatepickerOptions = {
    min: new Date(), // set the minimum date to today
    select: 'range',
    showRangeLabels: false,
    touchUi: true,
  };
  isEdit = false;
  inPersonZoomFollowUp = false;
  popupHeaderText!: string;
  popupAnchor: HTMLElement | undefined;
  calendarSelectedDate: any = new Date();
  selectedTime: any;
  popupAddButtons = [
    'cancel',
    {
      handler: () => {
        this.saveEvent();
      },
      keyCode: 'enter',
      text: 'Save',
      cssClass: 'mbsc-popup-button-primary',
    },
  ];
  popupEditButtons = [
    'cancel',
    {
      handler: () => {
        this.saveEvent();
      },
      keyCode: 'enter',
      text: 'Save',
      cssClass: 'mbsc-popup-button-primary',
    },
  ];
  popupButtons: any = [];
  popupOptions: MbscPopupOptions = {
    display: 'bottom',
    contentPadding: false,
    fullScreen: true,
    onClose: () => {
      if (!this.isEdit) {
        // refresh the list, if add popup was canceled, to remove the temporary event
        this.myEvents = [...this.myEvents];
      }
    },
    responsive: {
      medium: {
        display: 'anchored',
        width: 350,
        fullScreen: false,
        touchUi: false,
      },
    },
  };
  view: MbscEventcalendarView = {
    schedule: {
      type: 'week',
      allDay: false,
      // startDay: 1,
      // endDay: 5,
      startTime: WORKING_TIME_CONFIG.start,
      endTime: WORKING_TIME_CONFIG.end,
    },
  };
  datetimePickerControls = ['time'];
  loadPopupForm(event: MbscCalendarEvent): void {
    this.popupEventTitle =
      this.apptDetails.parentDetails.studentFirstName + "'s " + 'Follow Up';
    this.popupEventDescription = event['description'];
    this.popupEventDates = [
      new Date(event.start as Date),
      new Date(event.end as Date),
    ];
  }
  calendarOptions: MbscEventcalendarOptions = {
    clickToCreate: this.clickToCreate,
    dragToCreate: false,
    dragToMove: false,
    dragToResize: false,
    view: {
      schedule: { type: 'week' },
    },
    timezonePlugin: momentTimezone,
    dataTimezone: 'utc',
    displayTimezone: 'America/Chicago',

    onEventClick: (args) => {
      this.isEdit = true;
      this.tempEvent = args.event;
      // fill popup form with event data
      if (
        this.tempEvent.title ==
        this.apptDetails.parentDetails.studentFirstName + "'s " + 'Follow Up'
      ) {
        this.loadPopupForm(args.event);
        // set popup options
        this.popupHeaderText = 'Edit Follow Up';
        this.popupButtons = this.popupEditButtons;
        this.popupAnchor = args.domEvent.currentTarget;
        // open the popup
        this.popup.open();
      }
    },
    onEventCreated: (args) => {
      setTimeout(() => {
        this.isEdit = false;
        this.tempEvent = args.event;
        this.tempEvent.title = 'Follow Up';
        this.selectedTime = this.tempEvent.start;

        this.loadPopupForm(args.event);
        // set popup options
        this.popupHeaderText = 'Follow Up';
        this.popupButtons = this.popupAddButtons;
        this.popupAnchor = args.target;
        // open the popup
        this.popup.open();
        // }
      });
    },
    onEventDeleted: (args) => {
      setTimeout(() => {
        this.deleteEvent(args.event);
      });
    },
    onEventUpdated: (args) => {
      // here you can update the event in your storage as well, after drag & drop or resize
      this.saveEvent();
    },
  };

  saveEvent(): void {
    this.tempEvent.title = this.popupEventTitle;
    this.tempEvent['description'] = this.popupEventDescription;
    this.tempEvent.start = this.popupEventDates[0];
    this.tempEvent.end = this.popupEventDates[1];
    const start = new Date(this.tempEvent.start as Date);

    let year = start.getFullYear();
    let monthName = monthNames[start.getMonth()];
    let day = start.getDate();

    this.assessmentDate = monthName + ' ' + day + ', ' + year;
    var end = new Date(this.tempEvent.end as Date);
    this.appointmentTime =
      start.toLocaleString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      }) +
      ' - ' +
      end.toLocaleString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    if (this.isEdit) {
      // update the event in the list
      this.myEvents = [...this.myEvents];
      // here you can update the event in your storage as well
      // ...
    } else {
      // add the new event to the list
      this.myEvents = [...this.myEvents, this.tempEvent];
      // here you can add the event to your storage as well
      // ...
    }
    // navigate the calendar
    this.calendarSelectedDate = this.popupEventDates[0];
    this.reset = 'Reset';
    this.clickToCreate = '';

    // close the popup
    this.popup.close();
  }

  CreateFollowUp() {
    this.spinner.show();
    var startDate = new Date(this.tempEvent.start as Date);
    // var userTimezoneOffset = startDate.getTimezoneOffset() * 60000;
    // startDate = new Date(startDate.getTime() - userTimezoneOffset);

    var endDate = new Date(this.tempEvent.end as Date);
    // var userTimezoneOffset = endDate.getTimezoneOffset() * 60000;
    // endDate = new Date(endDate.getTime() - userTimezoneOffset);
    let followUpRequest = {
      title: this.popupEventTitle,
      appointmentDate: this.assessmentDate,
      appointmentTime: this.appointmentTime,
      appointmentId: this.apptId,
      start: startDate,
      end: endDate,
      appointmentComments: '',
      resource: this.tempEvent.resource,
      inZoom: this.inPersonZoomFollowUp,
    };

    this.appointmentService.submitfollowupReschedule(followUpRequest).subscribe(
      (res) => {
        this.spinner.hide();
        this.router.navigate(['/appt-all-details', this.apptId]);
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }

  deleteEvent(event: MbscCalendarEvent): void {
    if (this.reset == 'Reset') {
      this.myEvents = this.myEvents.filter((item) => item.id !== event.id);
      this.reset = 'Close';
      this.assessmentDate = '';
      this.appointmentTime = '';
      this.clickToCreate = 'single';
    }
  }
  onDeleteClick(): void {
    if (this.reset == 'Reset') {
      this.deleteEvent(this.tempEvent);
      this.popup.close();
    }
  }
  getAdminName() {
    this.myResources.forEach((element) => {
      if (element.id == this.tempEvent.resource) {
        this.assignedAdmin = element.name;
      }
      setTimeout(() => {
        jQuery('#followupConfirmationModal').modal('show');
      });
    });
  }
}
